"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PROJECT_LOCALIZATIONS = exports.PROJECT_SNIPPETS = exports.PROJECT_TEMPLATES = exports.PROJECT_PLUGINS = exports.PROJECT_CUSTOM_DATA_MAPPINGS = exports.PROJECT_CUSTOM_COMPONENTS = exports.PROJECT_EXTERNAL_APIS = exports.PROJECT_EVENTS = exports.PROJECT_COLLECTION_SNAPSHOT_DETAIL = exports.COLLECTION_DETAIL_FOR_QUERY = exports.PROJECT_SNIPPET_SNAPSHOT_DETAIL = exports.PROJECT_PAGE_SNAPSHOT_DETAIL = exports.PROJECT_DETAIL = exports.PROJECT_LIST = exports.ERROR_404_PAGE = exports.DEFAULT_PAGE = exports.PROJECT_PAGE_DETAIL = exports.PROJECT_FOLDER_LIST = exports.FOLDER_LIST = exports.COLLECTION_BY_UUID = exports.COLLECTION_BY_NAME = exports.PROJECT_COLLECTION = exports.PROJECT_DOMAIN_COLLECTIONS = exports.PROJECT_COLLECTIONS = void 0;
exports.PROJECT_COLLECTIONS = "project-collections";
exports.PROJECT_DOMAIN_COLLECTIONS = "project-domain-collections";
exports.PROJECT_COLLECTION = "project-collection";
exports.COLLECTION_BY_NAME = "collection-by-name";
exports.COLLECTION_BY_UUID = "collection-by-uuid";
exports.FOLDER_LIST = "folder-list";
exports.PROJECT_FOLDER_LIST = "project-folder-list";
exports.PROJECT_PAGE_DETAIL = "project-page-detail";
exports.DEFAULT_PAGE = "default-page";
exports.ERROR_404_PAGE = "404";
exports.PROJECT_LIST = "project_list";
exports.PROJECT_DETAIL = "project_detail";
exports.PROJECT_PAGE_SNAPSHOT_DETAIL = "project_page_snapshot_detail";
exports.PROJECT_SNIPPET_SNAPSHOT_DETAIL = "project_snippet_snapshot_detail";
exports.COLLECTION_DETAIL_FOR_QUERY = "collection-detail-for-query";
exports.PROJECT_COLLECTION_SNAPSHOT_DETAIL = "project_collection_snapshot_detail";
//Exchange
exports.PROJECT_EVENTS = "project-events";
exports.PROJECT_EXTERNAL_APIS = "project-external-apis";
exports.PROJECT_CUSTOM_COMPONENTS = "project-custom-components";
exports.PROJECT_CUSTOM_DATA_MAPPINGS = "project-custom-data-mappings";
exports.PROJECT_PLUGINS = "project-plugins";
exports.PROJECT_TEMPLATES = "project-templates";
exports.PROJECT_SNIPPETS = "project-snippets";
exports.PROJECT_LOCALIZATIONS = "project-localizations";